import { ArrowRight, Building2, CreditCard, Palette, Receipt } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Card } from '@/components/ui/Card';
import { PageHeader } from '@/components/ui/PageHeader';

interface Tile {
  to: string;
  icon: LucideIcon;
  title: string;
  description: string;
}

const TILES: Tile[] = [
  {
    to: '/settings/profile',
    icon: Building2,
    title: 'Business profile',
    description: 'Shop name, GSTIN, address — what shows on every bill.',
  },
  {
    to: '/settings/theme',
    icon: Palette,
    title: 'Theme & appearance',
    description: 'Pick a brand colour and switch to dark mode.',
  },
  {
    to: '/subscription',
    icon: CreditCard,
    title: 'Subscription',
    description: 'Your current plan, billing and renewal info.',
  },
  {
    to: '/branches',
    icon: Receipt,
    title: 'Branches & GST config',
    description: 'Multiple locations, per-branch GSTIN and bill prefix.',
  },
];

export function SettingsHubPage() {
  return (
    <>
      <PageHeader
        title="Settings"
        description="Tweak how New Vishwas Electronics looks, feels and bills."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {TILES.map((t) => {
          const Icon = t.icon;
          return (
            <Link key={t.to} to={t.to} className="group">
              <Card className="hover:border-brand-500 transition-colors h-full">
                <div className="flex items-start gap-3">
                  <div className="h-10 w-10 rounded-xl bg-brand-500/10 text-brand-700 grid place-items-center flex-shrink-0">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-ink">{t.title}</h3>
                    <p className="text-sm text-ink-soft mt-1">{t.description}</p>
                  </div>
                  <ArrowRight className="h-4 w-4 text-ink-soft group-hover:text-brand-700 group-hover:translate-x-0.5 transition-all" />
                </div>
              </Card>
            </Link>
          );
        })}
      </div>
    </>
  );
}
